import { render, staticRenderFns } from "./VuetiTable.vue?vue&type=template&id=a4395420"
import script from "./VuetiTable.vue?vue&type=script&lang=js"
export * from "./VuetiTable.vue?vue&type=script&lang=js"
import style0 from "./VuetiTable.vue?vue&type=style&index=0&id=a4395420&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports